import React, { useState } from 'react';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import './Analyze.scss';
import Historico from './BotReport/Historico';
import DashboardReport from './DashboardReport/DashboardReport';
import Metricas from './BotReport/BotGeneralStatus';
import BotReport from './BotReport/BotReport';
import IaReport from './IaReport/IaReport';
import { dashboardType } from './DashboardReport/index';
import { CompanyActions } from '../../../store/actions/companies';
import { BotsCreators } from '../../../store/actions/bots';

function Analyze(props) {
  const { i18n, filter, retrieveBotRequest, getOrganizations } = props;
  const [page, setPage] = useState('relatorioBot'); // dashboard
  const [subPage, setSubPage] = useState('qtdUsuario');
  const [subPageIa, setSubPageIa] = useState('entendidas');

  const clickPage = (pagina) => {
    setPage(pagina);
    if (pagina === 'relatorioBot') {
      setSubPage('qtdUsuario');
    } else if (pagina === 'relatorioIa') {
      setSubPageIa('entendidas');
    }
  };

  const clickSubPage = (pagina) => {
    setSubPage(pagina);
  };

  const clickSubPageIa = (pagina) => {
    setSubPageIa(pagina);
  };

  return (
    <div>
      <div className="container-menu">
        <div className="container-analise-menu">
          <div className="analise-menu">
            <div
              // onClick={() => clickPage('dashboard')}
              style={{ cursor: 'pointer' }}
              className={
                page === 'dashboard'
                  ? 'settings-tab-menu-title settings-tab-menu-item'
                  : 'settings-tab-menu-items settings-tab-menu-item'
              }
            >
              <div className="subtopic-text">
                {i18n.t('Meu Dashboard')}
                <div className="soon-text-box">
                  <p className="soon-text">em breve</p>
                </div>
              </div>
            </div>
            <div
              onClick={() => clickPage('relatorioBot')}
              style={{ cursor: 'pointer' }}
              className={
                page === 'relatorioBot'
                  ? 'settings-tab-menu-title settings-tab-menu-item'
                  : 'settings-tab-menu-items settings-tab-menu-item'
              }
            >
              {i18n.t('Relatórios do bot')}
            </div>
            {page === 'relatorioBot' && (
              <div className="border-div-sub-menu">
                <div
                  onClick={() => clickSubPage('qtdUsuario')}
                  style={{ cursor: 'pointer' }}
                  className={
                    subPage === 'qtdUsuario'
                      ? 'settings-click-sub-menu settings-tab-sub-menu-item'
                      : 'settings-tab-sub-menu-item'
                  }
                >
                  {i18n.t('Quantidade de Clientes')}
                </div>
                <div
                  onClick={() => clickSubPage('qtdMensagens')}
                  style={{ cursor: 'pointer' }}
                  className={
                    subPage === 'qtdMensagens'
                      ? 'settings-click-sub-menu settings-tab-sub-menu-item'
                      : ' settings-tab-sub-menu-item'
                  }
                >
                  {i18n.t('Quantidade de Mensagens')}
                </div>
                <div
                  onClick={() => clickSubPage('qtdSessoes')}
                  style={{ cursor: 'pointer' }}
                  className={
                    subPage === 'qtdSessoes'
                      ? 'settings-click-sub-menu settings-tab-sub-menu-item'
                      : ' settings-tab-sub-menu-item'
                  }
                >
                  {i18n.t('Quantidade de Sessões')}
                </div>
                <div
                  onClick={() => clickSubPage('qtdMensagemCanal')}
                  style={{ cursor: 'pointer' }}
                  className={
                    subPage === 'qtdMensagemCanal'
                      ? 'settings-click-sub-menu settings-tab-sub-menu-item'
                      : ' settings-tab-sub-menu-item'
                  }
                >
                  {i18n.t('Quant. Mensagens por Canal')}
                </div>
                <div
                  onClick={() => clickSubPage('tempoAtendimento')}
                  style={{ cursor: 'pointer' }}
                  className={
                    subPage === 'tempoAtendimento'
                      ? 'settings-click-sub-menu settings-tab-sub-menu-item'
                      : ' settings-tab-sub-menu-item'
                  }
                >
                  {i18n.t('Tempo de atendimento')}
                </div>
                <div
                  // onClick={() => clickSubPage('fluxoArvore')}
                  style={{ cursor: 'pointer' }}
                  className={
                    subPage === 'fluxoArvore'
                      ? 'settings-click-sub-menu settings-tab-sub-menu-item'
                      : ' settings-tab-sub-menu-item'
                  }
                >
                  <div className="subtopic-text">
                    {i18n.t('Fluxo de árvore')}
                    <div className="soon-text-box">
                      <p className="soon-text">em breve</p>
                    </div>
                  </div>
                </div>
                <div
                  // onClick={() => clickSubPage('demografia')}
                  style={{ cursor: 'pointer' }}
                  className={
                    subPage === 'demografia'
                      ? 'settings-click-sub-menu settings-tab-sub-menu-item'
                      : ' settings-tab-sub-menu-item'
                  }
                >
                  <div className="subtopic-text">
                    {i18n.t('Demografia')}
                    <div className="soon-text-box">
                      <p className="soon-text">em breve</p>
                    </div>
                  </div>
                </div>
                <div
                  // onClick={() => clickSubPage('tags')}
                  style={{ cursor: 'pointer' }}
                  className={
                    subPage === 'tags'
                      ? 'settings-click-sub-menu settings-tab-sub-menu-item bb-i'
                      : ' settings-tab-sub-menu-item'
                  }
                >
                  <div className="subtopic-text">
                    {i18n.t('Tags')}
                    <div className="soon-text-box">
                      <p className="soon-text">em breve</p>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div
              // onClick={() => clickPage('relatorioIa')}
              style={{ cursor: 'pointer' }}
              className={
                page === 'relatorioIa'
                  ? 'settings-tab-menu-title settings-tab-menu-item'
                  : 'settings-tab-menu-items settings-tab-menu-item'
              }
            >
              <div className="subtopic-text">
                {i18n.t('Relatório de I.A')}
                <div className="soon-text-box">
                  <p className="soon-text">em breve</p>
                </div>
              </div>
            </div>
            {page === 'relatorioIa' && (
              <div className="border-div-sub-menu">
                <div
                  onClick={() => clickSubPageIa('entendidas')}
                  style={{ cursor: 'pointer' }}
                  className={
                    subPageIa === 'entendidas'
                      ? 'settings-click-sub-menu settings-tab-sub-menu-item'
                      : 'settings-tab-sub-menu-items settings-tab-sub-menu-item'
                  }
                >
                  {i18n.t('Não entendidas')}
                </div>
                <div
                  onClick={() => clickSubPageIa('intencao')}
                  style={{ cursor: 'pointer' }}
                  className={
                    subPageIa === 'intencao'
                      ? 'settings-click-sub-menu settings-tab-sub-menu-item'
                      : 'settings-tab-sub-menu-items settings-tab-sub-menu-item'
                  }
                >
                  {i18n.t('Uso de Intenções')}
                </div>
                <div
                  onClick={() => clickSubPageIa('desempenho')}
                  style={{ cursor: 'pointer' }}
                  className={
                    subPageIa === 'desempenho'
                      ? 'settings-click-sub-menu settings-tab-sub-menu-item'
                      : 'settings-tab-sub-menu-items settings-tab-sub-menu-item'
                  }
                >
                  {i18n.t('Desempenho de intenções')}
                </div>
              </div>
            )}
            <div
              onClick={() => clickPage('historico')}
              style={{ cursor: 'pointer' }}
              className={
                page === 'historico'
                  ? 'settings-tab-menu-title settings-tab-menu-item'
                  : 'settings-tab-menu-items settings-tab-menu-item'
              }
            >
              {i18n.t('Histórico de mensagens')}
            </div>
            <div
              onClick={() => clickPage('statusGeral')}
              style={{ cursor: 'pointer' }}
              className={
                page === 'statusGeral'
                  ? 'settings-tab-menu-title settings-tab-menu-item'
                  : 'settings-tab-menu-items settings-tab-menu-item'
              }
            >
              {i18n.t('Status Geral')}
            </div>
          </div>
        </div>
        {page === 'dashboard' && (
          <div className="container-menu-select">
            <DashboardReport
              filter={filter}
              dashboardType={dashboardType.BOT}
            />
          </div>
        )}
        {page === 'historico' && (
          <div className="container-menu-select">
            <Historico />
          </div>
        )}
        {page === 'relatorioBot' && (
          <div className="container-menu-select">
            <BotReport subPage={subPage} />
          </div>
        )}
        {page === 'relatorioIa' && (
          <div className="container-menu-select">
            <IaReport subPageIa={subPageIa} />
          </div>
        )}
        {page === 'statusGeral' && (
          <div className="container-menu-select">
            <Metricas />
          </div>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  bot: state.bots.bot,
  filter: state.filter,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...BotsCreators, ...CompanyActions }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Analyze))
);
